// i18next-extract-mark-ns-start LandingAds

import { graphql } from 'gatsby';
import React from 'react';

import { useTranslation } from 'react-i18next';
import { mostFrequentQuestions } from '../../components/home/faqQuestions';
import FAQBlock from '../../components/FAQBlock';
import Feedbacks from '../../components/home/v5/Feedbacks';
import HeaderLP from '../../components/LandingPage/HeaderLP';
import { Container, Content } from '../../components/home/v2/styledComponents';
import MenuBar from '../../components/home/MenuBar';
import FootNote from '../../components/LandingPage/FootNote';
import Footer from '../../components/home/v3/Footer';
import Layout from '../../layouts/index';
import bannerLeatherGoods from '../../assets/bannerLeathergoods.jpg';
import TaglineCard from '../../components/home/TaglineCard1';
import OurPartners from '../../components/home/v4/OurPartners';

import withOrderContext from '../../withOrderContext';
import WorksBanner from '../../components/WorksBanner';
import HowItWorksBlockLandingPage from '../../components/home/HowItWorks/HowItWorksBlockLandingPage';
import TipsServices from '../../components/home/OurServices/TipsServices';
import { getLeatherGoodsArticles } from '../../components/home/OurServices/LeatherGoodsServices';
import { TFunction } from '../../types/t-types';
import brush from '../../assets/benefits/brush.svg';
import hammer from '../../assets/benefits/hammer.svg';
import leatherGoods from '../../assets/benefits/leathergoods.svg';

const LandingMainLeatherGoodsProps = {
  slug: 'MainLeatherGoodsPage',
  path: '/maroquinerie/',
  preFilledSteps: {
    selectedCategory: 'accessories',
  },
  footNote: {
    title: 'En savoir plus',
    // eslint-disable-next-line max-len
    paragraph: "Pourquoi choisir Tilli pour l'entretien et la réparation de vos articles de maroquinerie ? \n\nDepuis plusieurs années, chez Tilli, nous nous engageons à donner une seconde vie à votre dressing et votre décoration. Nos artisans experts sont là pour vous accompagner dans l'entretien, la retouche, la réparation et la transformation de vos vêtements et de votre linge de maison. \n\nAfin de permettre à votre dressing de durer dans le temps, nous avons étendu notre expertise aux articles en cuir. Grâce à notre réseau d'experts, nous vous proposons désormais un service de maroquinerie, 7 jours sur 7, où que vous soyez car il vous suffit de nous envoyer votre accessoire par colis. \n\nBénéficiez des conseils et de l'expertise de nos artisans qui sauront choisir le soin le plus adapté à votre sac ou accessoire et vous présenteront plusieurs solutions selon votre budget. Nos artisans sélectionnés avec soin sont en mesure de réparer minutieusement les éraflures, de remplacer les pièces usées comme les zips ou les boucles, voire de remplacer des empiècements entiers si nécessaire. Une fois que vous aurez convenu des réparations à effectuer avec l'artisan, celui-ci se mettra à l'œuvre et vous renverra votre article soigneusement rénové dans un délai de 7 à 15 jours. \n\nNe laissez plus vos vieux accessoires de côté, rejoignez Tilli dans cette boucle vertueuse de réparation, d'entretien et de personnalisation de vos articles préférés. \n\nProlongez la durée de vie de vos produits sans contrainte grâce à Tilli, sans même quitter le confort de votre maison et pour le même prix que dans votre maroquinerie de quartier.",
    links: [],
    breadcrumbIntro: {
      // eslint-disable-next-line max-len
      paragraph: "Votre service d'artisans experts en maroquinerie, disponible à <link>Paris<link>, <link>Lyon<link>, <link>Bordeaux<link>, <link>Marseille<link>, <link>Toulouse<link>, <link>Nantes<link>, <link>Rennes<link>, <link>Lille<link>, <link>Nice<link>, <link>Montpellier<link> et dans une quinzaine d’autres villes en France ou à <link>Bruxelles<link>.",
      links: [
        '/maroquinerie/paris/',
        '/maroquinerie/lyon/',
        '/maroquinerie/bordeaux/',
        '/maroquinerie/marseille/',
        '/maroquinerie/toulouse/',
        '/maroquinerie/nantes/',
        '/maroquinerie/rennes/',
        '/maroquinerie/lille/',
        '/maroquinerie/nice/',
        '/maroquinerie/montpellier/',
        '/maroquinerie/bruxelles/'],
    },
    showFAQ: false,
  },
  breadcrumb: [
    { name: 'Accueil', item: '/' },
    { name: 'Maroquinerie', item: '/maroquinerie/' },
  ],
};

const tagline = 'confiez vos sacs abîmés à nos experts maroquiniers';

export const getLeatherGoodsHeaderSteps = (t: TFunction) => [
  t('Créez votre devis en ligne en 2 minutes'),
  t('Service rapide : votre commande prête sous 7 jours après validation du devis'),
  t('Livraison sécurisée pour vos produits de valeur'),
];

export const getLeatherGoodsServices = (t: TFunction) => [
  {
    title: t('Entretien'),
    text: t('Ceinture, sac, pochette'),
    icon: leatherGoods,
  },
  {
    title: t('Réparation'),
    text: t('Ceinture, sac, pochette'),
    icon: hammer,
  },
  {
    title: t('Recoloration'),
    text: t('Ceinture, sac, pochette'),
    icon: brush,
  },
];

function LandingMainLeatherGoods() {
  const {
    slug, footNote, breadcrumb,
  } = LandingMainLeatherGoodsProps;
  const { t } = useTranslation();

  return (
    <Layout routeSlug={slug}>
      <Container>
        <Content full hasNoBanner>
          <MenuBar />
          <HeaderLP
            image={bannerLeatherGoods}
            title={t('Votre service de maroquinerie,\n livré chez vous')}
            preFilledSteps={{ selectedCategory: 'accessories' }}
            subtitle={t('Confiez vos sacs et accessoires à l’expertise de nos artisans maroquiniers ')}
            steps={getLeatherGoodsHeaderSteps(t)}
            isPackage
          />
          <WorksBanner works={getLeatherGoodsServices(t)} marginTop />
          <TaglineCard tagline={tagline} />
          <HowItWorksBlockLandingPage landingPageType="package" />
          <TipsServices articles={getLeatherGoodsArticles(t)} noTitle />
          <Feedbacks marginTop />
          <FAQBlock questions={mostFrequentQuestions(t)} />
          <OurPartners isLandingPage />
          <FootNote
            title={footNote.title}
            paragraph={footNote.paragraph}
            breadcrumbIntro={footNote.breadcrumbIntro.paragraph}
            breadcrumbIntroLinks={footNote.breadcrumbIntro.links}
            links={footNote.links}
            showFAQ={footNote.showFAQ}
            itemListElement={breadcrumb}
            isLeatherGoods
          />
          <Footer isLeatherGoods />
        </Content>
      </Container>
    </Layout>
  );
}

export default withOrderContext(LandingMainLeatherGoods);

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(
      filter: { language: { eq: $language } }
    ) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;
